// extracted by mini-css-extract-plugin
export default {"policy":"PrivacyPolicySign_policy__rAmXK"};